export default __webpack_public_path__ + "static/media/grid3.0c3fff86.jpg";